export const INCOME = 1;
export const COST = 2;
export const DEDUCTION = 2;
export const EVIDENCE_KIND_INCOME = INCOME;
export const EVIDENCE_KIND_COST = COST;
export const EVIDENCE_KIND_DEDUCTION = DEDUCTION;

export const CALCULATOR_SOURCE_NETTO = 'netto';
export const CALCULATOR_SOURCE_BRUTTO = 'brutto';
export const CALCULATOR_SOURCE_VAT = 'vat';
export const CALCULATOR_DEFAULT_SOURCE = CALCULATOR_SOURCE_NETTO;

export const EVIDENCE_TYPE_KPIR = 1;
export const EVIDENCE_TYPE_KPIR_NAME = 'KPiR';
export const EVIDENCE_TYPE_RYCZALT = 2;
export const EVIDENCE_TYPE_RYCZALT_NAME = 'Ryczałt';
export const EVIDENCE_TYPE_KH = 3;
export const EVIDENCE_TYPE_KH_NAME = 'KH';
export const EVIDENCE_TYPE_KH_FULL_NAME = 'Księgi handlowe';

export const EVIDENCE_PURCHASE_VAT = 1;
export const EVIDENCE_SALE_VAT_ID = 8;

export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_RYCZALT_INCOME_MAIN = 'Sprzedaż towarów i usług';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_RYCZALT_INCOME_OTHER = 'Pozostałe przychody';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_RYCZALT_DEDUCTION_MAIN = 'Zakup towarów i usług';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_RYCZALT_DEDUCTION_OTHER = 'Pozostałe koszty';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_KPIR_INCOME_MAIN = 'Sprzedaż towarów i usług';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_KPIR_INCOME_OTHER = 'Pozostałe przychody';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_KPIR_DEDUCTION_MAIN = 'Zakup towarów';
export const EVIDENCE_INTERNALEVIDENCEENTRYTYPNAME_KPIR_DEDUCTION_OTHER = 'Pozostałe koszty';

export const EVIDENCE_KPIR_POZOSTALE_WYDATKI_ID = 6;

export const EVIDENCE_VEHICLE_DEDUCTION_TYPE_EKSPLOATACJA_ID = 1;
export const EVIDENCE_VEHICLE_DEDUCTION_TYPE_EKSPLOATACJA_NAME = 'eksploatacja';
export const EVIDENCE_VEHICLE_DEDUCTION_TYPE_KOSZT_POJAZDU_ID = 2;
export const EVIDENCE_VEHICLE_DEDUCTION_TYPE_KOSZT_POJAZDU_NAME = 'koszt pojazdu';

export const EVIDENCE_QUARTERLY_TYPE = 2;
export const EVIDENCE_MONTHLY_TYPE = 1;

export const EVIDENCE_KPIR_ENTRY_TYPE_POZOSTALE_PRZYCHODY = 2;
export const EVIDENCE_KPIR_ENTRY_TYPE_POZOSTALE_WYDATKI = 6;

export const PERIOD_TYPE_MONTH = 'month';
export const PERIOD_TYPE_QUARTER = 'quarter';
export const PERIOD_TYPE_YEAR = 'year';

export const MONTHS = [
  { name: 'Styczeń', month: 1, period_type: 'month' },
  { name: 'Luty', month: 2, period_type: 'month' },
  { name: 'Marzec', month: 3, period_type: 'month' },
  { name: 'Kwiecień', month: 4, period_type: 'month' },
  { name: 'Maj', month: 5, period_type: 'month' },
  { name: 'Czerwiec', month: 6, period_type: 'month' },
  { name: 'Lipiec', month: 7, period_type: 'month' },
  { name: 'Sierpień', month: 8, period_type: 'month' },
  { name: 'Wrzesień', month: 9, period_type: 'month' },
  { name: 'Październik', month: 10, period_type: 'month' },
  { name: 'Listopad', month: 11, period_type: 'month' },
  { name: 'Grudzień', month: 12, period_type: 'month' },
];

export const QUARTERS = [
  { name: 'I kwartał', quarter: 1, period_type: 'quarter' },
  { name: 'II kwartał', quarter: 2, period_type: 'quarter' },
  { name: 'III kwartał', quarter: 3, period_type: 'quarter' },
  { name: 'IV kwartał', quarter: 4, period_type: 'quarter' },
];

export const OTHERS = [
  { name: 'Rok', period_type: 'year' },
];

export const VAT_REGISTER_VAT_OUTCOME = 1;
export const VAT_REGISTER_TYPE_WNT = 3;
export const VAT_REGISTER_VAT_INCOME = 8;
export const VAT_REGISTER_TYPE_WDT = 10;
export const VAT_REGISTER_TYPE_SWIADCZENIE_USLUG_ART_100_UST_1_PKT_4 = 12;
export const VAT_REGISTER_TYPE_WNT_NOWEGO_SRODKA_TRANSPORTU = 14;
export const VAT_REGISTER_TYPE_WNT_SRODKOW_TRWALYCH = 15;

export const EVIDENCE_ENTRY_TYPE_8_5_ID = 7;
export const KPIR_VALUE_OF_GOODS_AND_SERVICES_SOLD_ID = 1;

// Query parameters
export const LIST_NAME_QUERY_PARAM = 'list-name';
